import { Message, messageBannerFunctions, MessageTypes } from '@nhl/nhl-react-ui/lib/MessageBanner';

import ValidationError from 'media-base-ui/utils/ValidationError';
import { login, requestAccount, forgotPassword } from 'media-base-ui/utils/accountAPI';
import { sessionOperations } from 'media-base-ui/redux/ducks/session';

import actionCreators from './actionCreators';
import formTypes from './formTypes';

const changeValue = actionCreators.changeValue;
const displayForm = actionCreators.displayForm;
const resetValues = actionCreators.resetValues;
const loginResponse = actionCreators.loginResponse;

const submitLogin = (email, password) => async dispatch => {
    dispatch(actionCreators.requestLogin());

    try {
        const data = await login({
            email,
            password
        });
        dispatch(actionCreators.loginResponse(true, data.access_token, null));
        dispatch(sessionOperations.userLoginStatusResponse(true, null));
    } catch (errors) {
        if(await errorHandler(errors)) {
            dispatch(actionCreators.loginResponse(false, null, errors));
        } else {
            dispatch(actionCreators.loginResponse(false, null, []));
        }
    }
};

const submitForgotPassword = email => async dispatch => {
    dispatch(actionCreators.requestForgotPassword());

    try {
        await forgotPassword({email});
        dispatch(actionCreators.forgotPasswordResponse(true, []));
        dispatch(actionCreators.displayForm(formTypes.FORGOT_PASSWORD_COMPLETE));
    } catch (errors) {
        if (await errorHandler(errors)) {
            dispatch(actionCreators.forgotPasswordResponse(false, errors));
        } else {
            dispatch(actionCreators.forgotPasswordResponse(false, []));
        }
    }
};

const submitAccountRequest = entry => async dispatch => {
    dispatch(actionCreators.requestAccountRequest());

    try {
        await requestAccount({profile: entry});
        dispatch(actionCreators.accountRequestResponse(true, []));
        dispatch(actionCreators.displayForm(formTypes.REQUEST_COMPLETE));
    } catch (errors) {
        if (await errorHandler(errors)) {
            dispatch(actionCreators.accountRequestResponse(false, errors));
        } else {
            dispatch(actionCreators.accountRequestResponse(false, []));
        }
    }
};

// returns true if the error is validation related, false otherwise
const errorHandler = async errors => {
    if (errors[0] instanceof ValidationError) {
        messageBannerFunctions.dispatchMessage(new Message('There were some problems with the form. See below for more details.',
            MessageTypes.ERROR));
        return true;
    } else {
        let body = {};
        try {
            body = await errors.response.json();
        } catch(e) {
            messageBannerFunctions.dispatchMessage(new Message('We\'re having a problem on our end. Please try again later.',
                MessageTypes.ERROR));
            return false;
        }

        if (errors.response.status === 401 || errors.response.status === 404 || body.error === 'invalid_grant') {
            messageBannerFunctions.dispatchMessage(new Message('Your email address and password do not match an account in our records.',
                MessageTypes.ERROR));
        } else if (body.message.indexOf('existing') !== -1) {
            messageBannerFunctions.dispatchMessage(new Message('There is already an account for that email address. Please use another one.',
                MessageTypes.ERROR));
        } else {
            messageBannerFunctions.dispatchMessage(new Message('We\'re having a problem on our end. Please try again later.',
                MessageTypes.ERROR));
        }
        return false;
    }
};

export default {
    changeValue,
    displayForm,
    resetValues,
    loginResponse,
    submitLogin,
    submitForgotPassword,
    submitAccountRequest
};

